module.exports = __webpack_public_path__ + "media/images/lp_team-2-48151f37a6d008175152970f0d1ab28b.webp";